import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Button, Checkbox, Col, DatePicker, Form, message, Row, Table } from 'antd';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import moment from 'moment';
import { connect } from 'react-redux';

import { queryAnalysisOperational } from '@api/finance/budget';
import { BackBtn } from '@comm/BackBtn';
import {
  queryFinanceBooksOrg,
  queryFinanceBooksOrgList,
  queryFinanceOperationalStatistics,
} from '@api/finance/finance';
import util from '@util';
import getAllType from '@util/getAllType';
import LocalDb from '@util/localDb';
import { getLocalOperationalStatis } from '@store/modules/operational_statis';
import { saveIncomeInfo } from '@store/modules/income_info';

const FormItem = Form.Item;
const { RangePicker } = DatePicker;
const date = new Date();

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      org: props.operationalStatisStatus.org,
      isLoading: false,
      type: props.operationalStatisStatus.type,
      data: props.operationalStatisStatus.data,
      wid: props.operationalStatisStatus.wid,
      checkedUUids: props.operationalStatisStatus.checkedUUids,
      show: 'all', // all显示实际和预算，
      showChecked: ['ignore', 'noIgnore'],
      initDate: LocalDb.get('date')
        ? [moment(LocalDb.get('date').beginDate), moment(LocalDb.get('date').endDate)]
        : [moment.unix(date.getTime() / 1000), moment.unix(date.getTime() / 1000)],
      groupUuids: this.props.location.query.groupUuids || [],
    };
  }

  componentWillMount() {
    this.loadOrg();
    getAllType().then(res => {
      this.setState({
        type: res,
      });
    });
  }

  componentDidMount() {
    const table = document.getElementsByClassName('ant-table-scroll')[0];
    table.id = 'table-to-xls';

    const Btn = document.getElementsByClassName('ant-table-body')[0];
    const { scrollLeft } = this.props.operationalStatisStatus;
    const { scrollTop } = this.props.operationalStatisStatus;
    ReactDOM.findDOMNode(Btn).scrollTo(scrollLeft, scrollTop);
    const params = {};
    const { initDate } = this.state;
    params.beginDate = initDate[0];
    params.endDate = initDate[1];
    this.loadData(params);
  }

  componentWillUnmount() {
    const { scrollLeft } = document.getElementsByClassName('ant-table-body')[0];
    const { scrollTop } = document.getElementsByClassName('ant-table-body')[0];
    const { wid, checkedUUids, org, data, type } = this.state;
    this.props.dispatch(
      getLocalOperationalStatis({
        scrollLeft,
        scrollTop,
        checkedUUids,
        data,
        wid,
        org,
        type,
      }),
    );
  }

  /**
   * 获取资金统计列表
   */
  loadData = searchDate => {
    const { groupUuids } = this.state;
    this.setState({
      isLoading: true,
    });
    searchDate.beginDate = moment(searchDate.beginDate).format('YYYY-MM-DD');
    searchDate.endDate = moment(searchDate.endDate).format('YYYY-MM-DD');
    searchDate.groupUuids = groupUuids;
    groupUuids.length === 0
      ? queryFinanceOperationalStatistics(searchDate).then(res => {
          if (res.statusCode === 200) {
            const ignoreArr = res.data.ignore;
            this.setState({
              data: ignoreArr,
              isLoading: false,
            });
          } else {
            message.error(res.message);
          }
        })
      : queryAnalysisOperational(searchDate).then(res => {
          if (res.statusCode === 200) {
            const ignoreArr = res.data.ignore;
            this.setState({
              data: ignoreArr,
              isLoading: false,
            });
          } else {
            message.error(res.message);
          }
        });
  };

  initChecked = org => {
    const { checkedUUids } = this.state;

    if (checkedUUids.length > 0) {
      return this.loopchangeCheck(checkedUUids, org);
    }

    org.length > 0 &&
      org.map(item => {
        item.checked = true;
        checkedUUids.push(item.uuid);
        return item;
      });
    this.setState({
      checkedUUids,
    });
    return org;
  };

  /**
   * 获取账号列表
   */
  loadOrg = () => {
    const { groupUuids } = this.state;
    groupUuids.length === 0
      ? queryFinanceBooksOrg().then(res => {
          if (res.statusCode === 200) {
            const org = this.initChecked(res.data);
            this.setState({
              org,
              wid: res.data.length * 200 + 420,
            });
          }
        })
      : queryFinanceBooksOrgList({
          groupUuids,
        }).then(res => {
          if (res.statusCode === 200) {
            const org = this.initChecked(res.data);
            this.setState({
              org,
              wid: res.data.length * 200 + 420,
            });
          }
        });
  };

  handleSubmit = e => {
    if (e) {
      e.preventDefault();
    }
    const { date: propsDate } = this.props.form.getFieldsValue();
    const params = {};
    params.beginDate = propsDate[0];
    params.endDate = propsDate[1];
    LocalDb.set('date', params);
    this.loadData(params);
  };

  search = condition => {
    this.condition = condition;
    this.loadData(1);
  };

  toDetail = (uuid, igNore, typeUid) => {
    // igNore:0不忽略，1忽略
    const { dispatch } = this.props;
    const { type } = this.state;
    let types = [];
    let notTo = false;
    let ignoreFlag;
    if (typeUid !== 'payCurrents') {
      type.forEach(item => {
        if (item.value === typeUid) {
          types = item.children || [typeUid];
          const b = item.notTo;
          notTo = b;
        }
      });
    } else {
      ignoreFlag = 2;
    }
    dispatch(
      saveIncomeInfo({
        isShowPart: true,
        types,
        date: this.props.form.getFieldsValue().date,
        igLevel: 1,
        ignoreFlag,
      }),
    );
    if (!notTo) {
      if (types.every(item => item.indexOf('2') === 0)) {
        this.props.router.push(`/finance/operational/${uuid}/buddget`);
      } else {
        this.props.router.push(`/finance/statis/${uuid}/detail`);
      }
    }
  };

  toIgnore = () => {
    // igNore:0不忽略，1忽略
    const { dispatch } = this.props;
    dispatch(
      saveIncomeInfo({
        isShowPart: true,
        // 2 是走账数据
        isNonBusiness: true,
      }),
    );
    this.props.router.push(`/finance/statis/ignore`);
  };

  searchBar = () => {
    const { getFieldDecorator } = this.props.form;
    const { groupUuids } = this.state;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row type="flex" justify="start">
          {groupUuids.length !== 0 ? (
            <Col>
              <BackBtn />
            </Col>
          ) : null}
          <Col>
            <FormItem style={{ marginBottom: '16px' }}>
              {getFieldDecorator('date', {
                initialValue: this.state.initDate,
              })(<RangePicker />)}
            </FormItem>
          </Col>
          <Col>
            <FormItem style={{ marginBottom: '16px' }}>
              <Button type="primary" htmlType="submit" style={{ marginLeft: '10px' }}>
                搜索
              </Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  };

  /**
   * 跳转至按年统计详情页
   */
  toYearStatic = company => {
    this.props.router.push({
      pathname: `/finance/operational/${company.uuid}/year`,
      query: {
        companyName: company.companyName,
      },
    });
  };

  loopchangeCheck = (checkedUUids, org) => {
    org.length > 0 &&
      org.map(item => {
        const isChecked = checkedUUids.some(uuid => {
          return item.uuid === uuid;
        });
        item.checked = !!isChecked;
        return item;
      });
    return org;
  };

  changeCheck = key => {
    let { checkedUUids, org } = this.state;
    const isChecked = checkedUUids.some(item => {
      return item === key;
    });
    if (isChecked) {
      checkedUUids = checkedUUids.filter(item => {
        return item !== key;
      });
    } else {
      checkedUUids.push(key);
    }
    org = this.loopchangeCheck(checkedUUids, org);
    this.setState({
      checkedUUids,
      org,
    });
  };

  columns = () => {
    const { type } = this.state;
    const columns = this.state.org.map((item, index) => {
      const config = {};
      config.title = (
        <p style={{ textAlign: 'center' }}>
          <p>
            <Checkbox checked={item.checked} onClick={() => this.changeCheck(item.uuid)} />
            <span style={{ marginLeft: '5px' }}>{index + 1}</span>
          </p>
          <a onClick={() => this.toYearStatic(item)}>{item.companyName}</a>
          <p>{item.date ? `截止${item.date}` : ''}</p>
          <p>{item.remark ? `${item.remark}` : ''}</p>
        </p>
      );
      const orgUuid = item.uuid;
      config.dataIndex = item.uuid;
      config.key = item.uuid;
      config.width = 200;
      config.render = (text, record) => {
        if (text === 0) {
          return <span>-</span>;
        }
        return this.handlerItem(text, record, orgUuid);
      };
      return config;
    });
    columns.unshift({
      title: (
        <p style={{ textAlign: 'center' }}>
          <a />
          <p />
        </p>
      ),
      dataIndex: 'type',
      key: 'type',
      width: 200,
      fixed: 'left',
      render: text => {
        let typeName = '';
        let gs = '';
        const style = {};
        if (type.length > 0) {
          type.forEach(item => {
            if (text === item.value) {
              typeName = `${item.index ? `${item.index}、` : ''}${item.key}`;
              if (item.color) {
                style.color = item.color;
              }
              if (item.indexArr) {
                gs = item.indexArr.join('+');
                gs = `(${gs})`;
              }
              return typeName;
            }
          });
        }

        return (
          <span>
            <span style={style}>{typeName}</span>
            <p>{gs}</p>
          </span>
        );
      },
    });
    columns.push({
      title: '合计',
      dataIndex: 'sum',
      key: 'sum',
      width: 220,
      fixed: 'right',
      render: (text, record) => {
        return this.handlerItem(text, record, undefined);
      },
    });
    return columns;
  };

  setShow = key => {
    let { show, showChecked } = this.state;
    let flag = false;
    flag = showChecked.some(item => {
      return item === key;
    });
    if (flag) {
      showChecked = showChecked.filter(item => {
        return item !== key;
      });
    } else {
      showChecked.push(key);
    }
    if (showChecked.length === 2) {
      show = 'all';
    } else if (showChecked.length === 1) {
      show = showChecked[0];
    }

    this.setState({
      show,
      showChecked,
    });
  };

  handlerItemSum = record => {
    const { checkedUUids } = this.state;
    let ignoreSum = 0;
    let ignoreItem = 0;
    Object.keys(record).forEach(key => {
      if (checkedUUids.includes(key)) {
        ignoreItem = parseFloat(record[key]) * 100;
        ignoreSum += ignoreItem;
      }
    });
    ignoreSum /= 100;
    return {
      ignoreSum,
    };
  };

  handlerItem = (text, item, orgUuid) => {
    let ignoreFont;
    if (orgUuid) {
      ignoreFont = util.numberFormat(text, 2, '.', ',');
    } else {
      const sum = this.handlerItemSum(item);
      ignoreFont = util.numberFormat(sum.ignoreSum, 2, '.', ',');
    }
    if (ignoreFont === '0.00') {
      return <span>-</span>;
    }
    if (orgUuid !== undefined) {
      return <a onClick={() => this.toDetail(orgUuid, 1, item.type)}>{ignoreFont}</a>;
    }
    return <a>{ignoreFont}</a>;
  };

  render() {
    const { data, wid, isLoading } = this.state;
    return (
      <div className="statis-box">
        <Row type="flex">
          <Col style={{ textAlign: 'right' }} span={12}>
            {this.searchBar()}
          </Col>
          <Col span={12} style={{ textAlign: 'right' }}>
            <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="download-table-xls-button ant-btn"
              table="table-to-xls"
              filename="资金统计"
              sheet="资金统计"
              style={{
                marginTop: '4px',
              }}
              buttonText="导出"
            />
          </Col>
        </Row>
        <Table
          columns={this.columns()}
          dataSource={data}
          loading={isLoading}
          bordered
          size="small"
          scroll={{ x: wid, y: util.pageHeight() - 215 }}
          style={{}}
          pagination={false}
        />
      </div>
    );
  }
}

export default connect(state => ({
  operationalStatisStatus: state.operational_statis,
}))(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/finance/operational/Index.js